// extracted by mini-css-extract-plugin
export var chevronIcon = "_c6-2";
export var teamName = "_c6-1";
export var teamSwitcherButton = "_c6-0";